<template>
    <div>
        <div class="d-flex justify-content-between mb-2">
            <h3 class="card-title">Lista de Contractos</h3>
            <div class="d-flex">
                <PrimaryButton class="btn btn-primary ms-auto" data-toggle="modal" data-target="#contractModal"
                    @click="contractStore.openModal">
                    Generar
                </PrimaryButton>
            </div>
        </div>

        <div class="d-flex mt-3 mb-3">
            <input type="text" class="form-control" placeholder="Buscar Contrato..."
                v-model="contractStore.searchString" />
        </div>

        <div>
            <ContractTable :contracts="contractStore.paginatedContracts" @sort="contractStore.sortBy($event)"
                @edit="contractStore.editContract($event)" />
            <Pagination v-if="contractStore.filteredContract.length > contractStore.itemsPerPage"
                :list="contractStore.filteredContract" :items-per-page="contractStore.itemsPerPage"
                :current-page="contractStore.currentPage" @current-page="contractStore.setCurrentPage($event)" />
        </div>

        <Modal modal-id="contractModal" :customClass="'modal-xl'">
            <div class="modal-header">
                <h4 class="modal-title">Contrato</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="contractStore.closeModal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="col-12 col-md-3 col-lg-3 content-col">
                                <label for="applicationSelect" class="mb-0 font-weight-lb">Solicitud:</label>
                            </div>

                            <div class="col-12 col-md-4 col-lg-4" v-show="!contractStore.isEdit">
                                <select id="applicationSelectC" v-model="contractStore.selectedApplication"
                                    class="form-select selectpicker border-dark" data-width="100%"
                                    data-live-search="true" :disabled="!contractStore.loanApplicationsOptions.length"
                                    title="Selecciona solicitud...">
                                    <option value="" disabled>Selecciona solicitud</option>
                                    <option v-for="application in contractStore.loanApplicationsOptions"
                                        :key="application.id" :value="application">
                                        {{ application.referenceNumber }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4 col-lg-4" v-show="contractStore.isEdit">
                                <label for="applicationSelect" class="mb-0 font-weight-lb">
                                    {{ contractStore.formSaveCOAS.referenceNumber }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="viewContract === 0">
                    </div>
                    <!--CONTRATO DE APERTURA DE CRÉDITO (TARJETA AMERICAN EXPRESS)-->
                    <div v-if="viewContract === 11">
                        <CreditOpeningAgreementPF />
                    </div>
                    <div v-if="viewContract === 13">
                        <CreditOpeningAgreementPM />
                    </div>
                    <!--CONTRATO DE APERTURA DE CRÉDITO CON GARANTÍA PRENDARIA (AUTOMOVIL)-->
                    <div v-if="viewContract === 'COAGPPF'">
                        <CreditOpeningAgreementGuarantePrendariaPF />
                    </div>
                    <div v-if="viewContract === 'COAGPPM'">
                        <CreditOpeningAgreementGuarantePrendariaPM />
                    </div>
                    <!--CONTRATO DE APERTURA DE CRÉDITO SIMPLE-->
                    <div v-if="viewContract === 1">
                        <CreditOpeningAgreementSimplePF />
                    </div>
                    <div v-if="viewContract === 8">
                        <CreditOpeningAgreementSimplePM />
                    </div>
                    <!--CONTRATO DE CRÉDITO CON GARANTÍA HIPOTECARIA-->
                    <div v-if="viewContract === 'CAGMPF'">
                        <CreditAgreementGuaranteMortgagePF />
                    </div>
                    <div v-if="viewContract === 'CAGMPM'">
                        <CreditAgreementGuaranteMortgagePM />
                    </div>
                    <!--CONTRATO DE CRÉDITO CON GARANTÍA PRENDARIA-->
                    <div v-if="viewContract === 9">
                        <CreditAgreementGuarantePrendariaPF />
                    </div>
                    <div v-if="viewContract === 10">
                        <CreditAgreementGuarantePrendariaPM />
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="contractStore.closeModal">
                    {{ $getLocaleMessage('buttons', 'cancel') }}
                </button>
            </div>
        </Modal>
    </div>
</template>

<!--Composition API-->
<script setup>
import { useContractStore } from '@/pinia/LoanApplications/Legal/useContractStore.module';
import { onMounted, nextTick, computed, watch, ref, getCurrentInstance } from "vue";
import Modal from '@/Components/Bootstrap/Modal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import CreditAgreementGuaranteMortgagePF from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditAgreementGuaranteMortgagePF.vue';
import CreditOpeningAgreementPF from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditOpeningAgreementPF.vue';
import CreditOpeningAgreementPM from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditOpeningAgreementPM.vue';
import CreditOpeningAgreementGuarantePrendariaPF from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditOpeningAgreementGuarantePrendariaPF.vue';
import CreditOpeningAgreementGuarantePrendariaPM from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditOpeningAgreementGuarantePrendariaPM.vue';
import CreditOpeningAgreementSimplePF from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditOpeningAgreementSimplePF.vue';
import CreditOpeningAgreementSimplePM from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditOpeningAgreementSimplePM.vue';
import CreditAgreementGuaranteMortgagePM from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditAgreementGuaranteMortgagePM.vue';
import CreditAgreementGuarantePrendariaPF from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditAgreementGuarantePrendariaPF.vue';
import CreditAgreementGuarantePrendariaPM from '@/Components/Forms/LoanApplications/Legal/ContractProducts/CreditAgreementGuarantePrendariaPM.vue';
import ContractTable from '@/Components/Tables/ContractTable.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';

const contractStore = useContractStore();
const getSelectC = () => $('#applicationSelectC');
const viewContract = ref(0);

// Acceder a la instancia de la app
const app = getCurrentInstance();
const filters = app?.appContext.config.globalProperties.$filters;

// Inicializa el selectpicker
const initializeSelectPicker = () => {
    nextTick(() => {
        const select = getSelectC();
        if (select.length) {
            select.selectpicker('refresh');
            if (!contractStore.selectedApplication) {
                select.selectpicker('val', '');
            }
        }
    });
};

// Función para generar los objetos loanAmortizations y quotations
const generateLoanData = (newApp) => {
    const loanAmortizations = {
        id: newApp.prospectus?.quotations?.loanAmortizations?.id,
        installmentNumber: newApp.prospectus?.quotations?.loanAmortizations?.installmentNumber,
        startDate: filters?.formatDateForInput(newApp.prospectus?.quotations?.loanAmortizations?.startDate)
    };

    const quotations = {
        id: newApp?.prospectus?.quotations?.id,
        referenceNumber: newApp?.prospectus?.quotations?.referenceNumber,
        disbursementDate: filters?.formatDateForInput(newApp?.prospectus?.quotations?.disbursementDate),
        creditAmount: filters?.formatNumber(newApp?.prospectus?.quotations?.creditAmount),
        totalTerm: newApp?.prospectus?.quotations?.totalTerm,
        paymentPeriodAmount: filters?.formatNumber(newApp?.prospectus?.quotations?.paymentPeriodAmount),
        loanAmortizations
    };

    return { loanAmortizations, quotations };
};


// Watcher para isModalOpen
watch(
    () => contractStore.isModalOpen,
    (newValue) => {
        if (!newValue) {
            // Resetear el selectpicker
            initializeSelectPicker();
            // Resetear la hoja de contrato
            viewContract.value = 0;
        }
    },
);

// Watcher para las opciones del select
watch(
    () => contractStore.loanApplicationsOptions,
    async (newOptions) => {
        if (newOptions.length > 0 && contractStore.isModalOpen) {
            initializeSelectPicker();
        }
    },
    { deep: true }
);

// Watcher para actualizar nombre y fecha cuando cambia selectedApplication
watch(
    () => contractStore.selectedApplication,
    (newApp) => {
        viewContract.value = 0;

        if (!contractStore.isEdit) {
            contractStore.form = {};
            contractStore.formSaveCOAS = {};
        }

        if (newApp) {
            /**1 Diferenciar que producto es */
            let accredited = {};
            let quotations = {};
            let loanAmortizations = {};
            let legalRepresentative = {};

            /**Crédito simple PF || Crédito con garantía prendaría PF || Crédito simple con comisión e interés para tarjeta de crédito PF alias CONTRATO DE APERTURA DE CRÉDITO (TARJETA AMERICAN EXPRESS) - PF*/
            if (newApp.productType.id === 1 || newApp.productType.id === 9 || newApp.productType.id === 11) {
                // Generar los datos comunes del préstamo
                const loanData = generateLoanData(newApp);
                loanAmortizations = loanData.loanAmortizations;
                quotations = loanData.quotations;

                accredited = {
                    name: `${newApp.prospectus?.generalInformation?.firstName} ${newApp.prospectus?.generalInformation?.lastName} ${newApp.prospectus?.generalInformation?.mothersMaidenName}`,
                    rfc: newApp.prospectus?.generalInformation?.rfc,
                    typeIdentification: newApp.prospectus?.generalInformation?.identificationType,
                    numIdentification: newApp.prospectus?.generalInformation?.identificationNumber,
                    address: `${newApp.prospectus?.addressAccredited?.street} ${newApp.prospectus?.addressAccredited?.exteriorNumber} ${newApp.prospectus?.addressAccredited?.interiorNumber} ${newApp.prospectus?.addressAccredited?.district}`
                };
            }

            /**Crédito simple PM || Crédito con garantía prendaría PM || Crédito simple con comisión e interés para tarjeta de crédito PM alias CONTRATO DE APERTURA DE CRÉDITO (TARJETA AMERICAN EXPRESS) - PM*/
            if (newApp.productType.id === 8 || newApp.productType.id === 10 || newApp.productType.id === 13) {
                // Generar los datos comunes del préstamo
                const loanData = generateLoanData(newApp);
                loanAmortizations = loanData.loanAmortizations;
                quotations = loanData.quotations;

                accredited = {
                    nameCompany: newApp.prospectus.generalInformation.businessName,
                    name: `${newApp.prospectus?.legalRepresentative?.firstName} ${newApp.prospectus?.legalRepresentative?.lastName} ${newApp.prospectus?.legalRepresentative?.mothersMaidenName}`,
                    rfc: newApp.prospectus?.generalInformation?.rfc,
                    typeIdentification: newApp.prospectus?.legalRepresentative?.identificationType,
                    numIdentification: newApp.prospectus?.legalRepresentative?.identificationNumber,
                    address: `${newApp.prospectus?.addressAccredited?.street} ${newApp.prospectus?.addressAccredited?.exteriorNumber} ${newApp.prospectus?.addressAccredited?.interiorNumber} ${newApp.prospectus?.addressAccredited?.district}`
                };

                legalRepresentative = {
                    nameCompany: newApp.prospectus.generalInformation.businessName,
                    name: `${newApp.prospectus?.legalRepresentative?.firstName} ${newApp.prospectus?.legalRepresentative?.lastName} ${newApp.prospectus?.legalRepresentative?.mothersMaidenName}`,
                    rfc: newApp.prospectus.legalRepresentative.rfc,
                    typeIdentification: newApp.prospectus?.legalRepresentative?.identificationType,
                    numIdentification: newApp.prospectus?.legalRepresentative?.identificationNumber,
                    address: `${newApp.prospectus?.addressAccredited?.street} ${newApp.prospectus?.addressAccredited?.exteriorNumber} ${newApp.prospectus?.addressAccredited?.interiorNumber} ${newApp.prospectus?.addressAccredited?.district}`
                };
            }

            let data = {
                quotations,
                signatures: {
                    accredited,
                    legalRepresentative
                }
            };

            contractStore.form = data;
            viewContract.value = newApp.productType.id;
        }
    },
    { deep: true, immediate: true } // Agrega esto para que se ejecute al montar el componente immediate
);


// Cargar data al montar el componente
onMounted(async () => {
    //Cargar data de opciones de solicitud
    await contractStore.filterLoanApplications();
    await contractStore.fetchProductContract();
    //Inicializar el componente de selector
    initializeSelectPicker();
});
</script>